import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  save(event) {
    event.preventDefault();

    const multiSelectController = this.element.querySelector('[data-controller="multi-select-chips-with-search"]');
    if (!multiSelectController) return;

    const stimulus = this.application.getControllerForElementAndIdentifier(
      multiSelectController,
      'multi-select-chips-with-search'
    );

    if (!stimulus) return;

    const selectedLabels = stimulus.selectedOptions.map(opt => ({
      value: opt.value,
      name: opt.name || opt.label,
      color: opt.color || '',
      text_color: opt.text_color || ''
    }));

    window.dispatchEvent(new CustomEvent('quoteLabels:selected', {
      detail: { labels: selectedLabels }
    }));

    this._closeModal();
  }

  cancel(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    this._closeModal();
  }

  closeIfBackdrop(event) {
    if (event.target.id === 'add-quote-labels-modal') {
      this.cancel();
    }
  }

  _closeModal() {
    const modal = document.getElementById('add-quote-labels-modal');
    if (modal) {
      modal.classList.add('hidden');
      modal.classList.remove('flex');
    }
  }
}
